// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sIDA","controls":"styles_controls__3eIf9","charLimit":"styles_charLimit__3zkct","input":"styles_input__3Le5J","send":"styles_send__38HSF"};